import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  OnChanges,
  OnInit,
  output,
  signal,
  SimpleChanges,
} from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import {
  PageSizeDropdownComponent,
} from '@shared/components/paginator/page-size-dropdown/page-size-dropdown.component';
import { IPaginationProps } from '@shared/constants/models.const';
import { DEFAULT_PAGINATION } from '@shared/constants/enums.const';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-paginator',
  imports: [
    ButtonComponent,
    PageSizeDropdownComponent,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss',
})
export class PaginatorComponent implements OnInit, OnChanges {

  totalRecords = input<number>(0);
  props: IPaginationProps = DEFAULT_PAGINATION;
  pageSize = 10;
  pageNum = signal(1);
  pagesCount = 0;

  take = input(10);
  skip = input(0);


  pageSizeOptions = [5, 10, 15, 25, 50, 100];
  protected readonly ButtonTypes = BUTTON_TYPES;

  actByRoute = input(true);
  onPagination = output<IPaginationProps>();


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cd: ChangeDetectorRef,
  ) {

    effect(() => {
      if (!this.actByRoute()) {
        this.setPaginationFromQueryParams();
        this.setPagesCount();
      }
    }, {
      allowSignalWrites: true,
    });

  }


  ngOnInit(): void {
    this.setPaginationFromQueryParams();
    this.setPagesCount();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setPagesCount();
  }

  setPagesCount(): void {
    if (this.totalRecords()) {
      this.pagesCount = Math.ceil(this.totalRecords() / this.pageSize);
      this.cd.markForCheck();
    }
  }

  setPaginationFromQueryParams(): void {

    if (this.actByRoute()) {
      const qParams: IPaginationProps = this.route.snapshot.queryParams as IPaginationProps;
      if (qParams.take) {
        this.pageSize = Number(qParams.take);
        this.props.take = this.pageSize || 10;
      }
      if (qParams.skip) {
        this.pageNum.set((Number(qParams.skip) / this.pageSize) + 1);
        this.props.skip = Number(qParams.skip);
      }
    } else {
      this.pageSize = Number(this.take());
      this.props.take = this.pageSize || 10;

      this.pageNum.set((Number(this.skip()) / this.pageSize) + 1);
      this.props.skip = Number(this.skip());

    }

    this.cd.markForCheck();
  }

  decreasePage(): void {
    if (this.pageNum() > 1) {
      this.pageNum.set(this.pageNum() - 1);
      this.createProps();
    }
  }

  increasePage(): void {
    if (this.pageNum() < this.pagesCount) {
      this.pageNum.set(this.pageNum() + 1);
      this.createProps();
    }
  }

  pageSizeChanged($event: number) {
    if ($event !== this.pageSize) {
      this.pageSize = $event;
      this.pageNum.set(1);
      this.createProps();
      this.setPagesCount();
    }
  }

  createProps(): void {

    const newProps = {
      take: this.pageSize || 10,
      skip: (this.pageNum() - 1) * this.pageSize,
    };

    this.props = newProps;


    if (this.actByRoute()) {
      this.router.navigate([], {
        queryParams: newProps,
        queryParamsHandling: 'merge',
      });
    } else {
      this.onPagination.emit(newProps);
    }

  }

}
